import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-light bg-light" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent",
  style: {"justify-content":"space-between"}
}
const _hoisted_4 = {
  class: "navbar-nav me-auto mb-2 mb-lg-0 d-flex",
  id: "navbarFirstBlock"
}
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item dropdown" }
const _hoisted_11 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_12 = { class: "navbar-nav navbar-text" }
const _hoisted_13 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_14 = {
  key: 1,
  class: "nav-item dropdown"
}
const _hoisted_15 = {
  class: "nav-link dropdown-toggle",
  "data-bs-toggle": "dropdown",
  href: "#",
  role: "button",
  "aria-expanded": "false"
}
const _hoisted_16 = { class: "dropdown-menu" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = {
  key: 2,
  class: "nav-item"
}

import {useAuthStore} from '@/stores/auth';
import {hasProblemPermission, hasRootPermission, isLoggedIn} from "@/utils/accounts";
import {computed} from "vue";
import {useServerInfoStore} from "@/stores/serverInfo";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const authStore = useAuthStore();
const serverInfoStore = useServerInfoStore();
const servername = computed(() => serverInfoStore.server_info.site_name || "OrangeJudge");

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "navbar-brand",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(servername.value), 1)
        ]),
        _: 1
      }),
      _cache[19] || (_cache[19] = _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navbarSupportedContent",
        "aria-controls": "navbarSupportedContent",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "nav-link active"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("首頁", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/problems",
              class: "nav-link active"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("公開題目", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: "/contests",
              class: "nav-link active"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("競賽列表", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: "/test",
              class: "nav-link active"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("測試", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: "/status",
              class: "nav-link active"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("解題動態", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_10, [
            _cache[9] || (_cache[9] = _createElementVNode("a", {
              class: "nav-link dropdown-toggle",
              href: "#",
              id: "navbarDropdown",
              role: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false"
            }, " 關於 ", -1)),
            _createElementVNode("ul", _hoisted_11, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/about",
                  class: "dropdown-item"
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("評測系統", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "https://LittleOrange666.github.io/orangejudge/"
                }, "教程")
              ], -1)),
              _cache[8] || (_cache[8] = _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "/api/api-docs"
                }, "API")
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("ul", _hoisted_12, [
          (!_unref(isLoggedIn))
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createVNode(_component_router_link, {
                  to: "/login",
                  class: "nav-link active"
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("登入", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(isLoggedIn))
            ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                _createElementVNode("a", _hoisted_15, _toDisplayString(_unref(authStore).display_name), 1),
                _createElementVNode("ul", _hoisted_16, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      class: "dropdown-item",
                      to: `/user/${_unref(authStore).username}`
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("個人頁面 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      class: "dropdown-item",
                      to: `/status?user=${_unref(authStore).username}`
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("解題列表 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      class: "dropdown-item",
                      to: "/settings"
                    }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("帳號設定", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      class: "dropdown-item",
                      to: "/preferences"
                    }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("偏好設定", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  (_unref(hasProblemPermission))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_17, [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_unref(hasProblemPermission))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                        _createVNode(_component_router_link, {
                          class: "dropdown-item",
                          to: "/admin/problem"
                        }, {
                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createTextVNode("題目管理", -1)
                          ]))]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(hasRootPermission))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_19, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_unref(hasRootPermission))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                        _createVNode(_component_router_link, {
                          class: "dropdown-item",
                          to: "/admin"
                        }, {
                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                            _createTextVNode("管理介面", -1)
                          ]))]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(isLoggedIn))
            ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(authStore).logout()), ["prevent"])),
                  href: "#",
                  class: "nav-link active"
                }, "登出")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})